import { HOST_URL, LOGIN_PATH } from "../constants/backend";

function login(token) {
  return fetch(`${HOST_URL}${LOGIN_PATH}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error("Invalid response code");
  });
}

export { login };
